import { TrendingUp, MapPin } from "lucide-react";

const BoosterBanner = () => {
  return (
    <section className="py-16 lg:py-20 bg-cream" data-testid="booster-banner-section">
      <div className="container-tm">
        <div className="bg-ink rounded-3xl p-10 md:p-14 lg:p-16 grain-overlay relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-[400px] h-[400px] bg-gold/25 rounded-full blur-[120px] pointer-events-none" />
          <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] bg-sage/25 rounded-full blur-[120px] pointer-events-none" />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="flex items-center gap-3 mb-6">
                <span className="w-12 h-12 rounded-2xl bg-gold flex items-center justify-center">
                  <TrendingUp size={22} strokeWidth={1.8} className="text-white" />
                </span>
                <span className="overline text-gold">Performance</span>
              </div>
              <h2 className="font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                Boostez vos réservations
                <span className="italic text-gold"> d'au moins 30%</span>.
              </h2>
              <p className="mt-6 font-sans text-base md:text-lg text-white/75 leading-relaxed max-w-xl">
                Grâce à Terre et Mer, vous bénéficiez d'interlocuteurs locaux présents dans chaque ville. Réactivité, connaissance du terrain et optimisation continue de votre annonce.
              </p>
            </div>

            <div className="lg:col-span-5 flex flex-col gap-4">
              <Pill icon={<TrendingUp size={16} strokeWidth={2} className="text-gold" />} label="+30%" sub="Réservations en plus" />
              <Pill icon={<MapPin size={16} strokeWidth={2} className="text-gold" />} label="24 villes" sub="Bretagne · Côte d'Émeraude" />
              <Pill icon={<TrendingUp size={16} strokeWidth={2} className="text-gold" />} label="24h/24 · 7j/7" sub="Permanence de nuit incluse" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Pill = ({ icon, label, sub }) => (
  <div className="flex items-center gap-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl px-5 py-4 hover:bg-white/10 transition-colors">
    <span className="w-10 h-10 rounded-xl bg-gold/15 flex items-center justify-center shrink-0">
      {icon}
    </span>
    <div>
      <p className="font-serif text-2xl text-white leading-none">{label}</p>
      <p className="text-[11px] uppercase tracking-[0.2em] text-white/60 font-semibold mt-1.5">
        {sub}
      </p>
    </div>
  </div>
);

export default BoosterBanner;
